// src/components/HomePage.js
import React from 'react';
import Navbar from './Navbar';
import Banner from './Banner';
import Best from './Best';
import Test from './Test';
import Footer from './Footer';
import Hero from './Hero';
import Nav from './Nav'; // Importing Nav component
import Pop from './Pop'; // Importing Pop component



export default function HomePage() {
  return (
    <>
    <Nav />
      <Navbar />
      <Hero/>
      <Banner />
      <Best />
      <Test />
      <Footer />
<Pop/>
    </>
  );
}
